import request from '@/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/emp-business/blade-project/project/list',
    method: 'get',
    filterEmptyParams: true,
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getPage = (current, size, params) => {
  return request({
    url: '/emp-business/blade-project/project/page',
    method: 'get',
    filterEmptyParams: true,
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/emp-business/blade-project/project/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/emp-business/blade-project/project/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/emp-business/blade-project/project/save',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/emp-business/blade-project/project/update',
    method: 'post',
    data: row
  })
}

export const getProjectTree = params => {
  return request({
    url: '/emp-business/blade-project/project/tree',
    method: 'get',
    params,
  });
};

export const getProjectAreaTree = params => {
  return request({
    url: '/emp-business/blade-project/project/arealist',
    method: 'get',
    params,
  });
};

export const getProjectLazyTree = parentId => {
  return request({
    url: '/emp-business/blade-project/project/lazy-tree',
    method: 'get',
    params: {
      parentId,
    },
  });
};
export const getDeptLazyTree = parentId => {
  return request({
    url: '/blade-system/dept/lazy-tree',
    method: 'get',
    params: {
      parentId,
    },
  });
};